module.exports = __webpack_public_path__ + "media/images/ride_requests/arrows-up-down-1363e817330eb42484c93bd22fb0b0ee.svg";